const itemsData = {
  boxLines: [
    {
      rowList: [
        { title: "订单号: ", banding: "OrderNo", value: "", className: "c-code-color" },
        { title: "报关金额: ", banding: "CustomsAmount", value: "", className: "c-amount-color" },
        { title: "币别: ", banding: "CurrencyType", value: "" }
      ]
    },
    {
      rowList: [
        { title: "关税: ", banding: "TariffFee", value: "", dataType: 'number_show', isShow: 'true' },
        { title: "增值税:  ", banding: "VATFee", value: "", dataType: 'number_show', isShow: 'true' },
        { title: "代理费:  ", banding: "AgentFee", value: "", dataType: 'number_show', isShow: 'true' }
      ]
    },
    {
      rowList: [
        { title: "其他费用:  ", banding: "OtherFee", value: "", dataType: 'number_show', isShow: 'true' },
        { title: "税代费未付款:  ", banding: "UnPayFee", value: "", dataType: 'number_show', isShow: 'true' }
      ]
    },
    {
      rowList: [
        { title: "付汇状态: ", banding: "RemittanceStaus", value: "", className: 'c-three-color', dataType: 'number_show', isShow: 'true' },
        { title: "未付汇金额:  ", banding: "UnRemittanceAmount", value: "", dataType: 'number_show', isShow: 'true' }
      ]
    },
    {
      rowList: [
        { title: "开票状态: ", banding: "InvoicedStatus", value: "", className: 'c-two-color' },
        {
          title: "结算类型:  ",
          banding: "SettlementType",
          value: "",
          dataType: "Type",
          dataMap: { 1: "T.T(转账)", 2: "COD(支票结算)", 3: "不付货款", 4: "其他方式" },
          classMap: { 1: "c-one-color ", 2: "c-two-color", 3: "c-three-color", 4: "c-four-color" }
        }
      ]
    },
    {
      rowList: [{ title: "供应商：", banding: "SupplierName", value: "" }]
    }
  ]
};
export { itemsData };
